<template>
    <v-container fluid>
        <v-app-bar clipped-right flat class="main-app-bar">
            <v-app-bar-nav-icon @click.stop="drawer = true"
                v-if="this.$vuetify.breakpoint.mdAndDown"></v-app-bar-nav-icon>
            <v-app-bar-title>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title class="main-app-bar-title">
                            {{ getPageName }}
                            <span v-for="(badge, i) in getPageBadges" :key="i" class="main-app-bar-badge">{{ badge }}</span>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-app-bar-title>
            <v-spacer></v-spacer>
            <div class="app-bar-info-card mr-2">
                <div class="app-bar-info-name">Hi, {{ get_user.name }}</div>
                <div class="app-bar-info-sub">{{ get_user.email }}</div>
            </div>
            <div class="app-bar-info-card">
                <div class="app-bar-info-name">
                    <v-icon small style="margin-right:4px;vertical-align:middle;color:#3988AA;">mdi-clock-outline</v-icon>
                    {{ currentDateTime }}
                </div>
                <div class="app-bar-info-sub pl-1">{{ userTimezone }}</div>
            </div>
        </v-app-bar>
        <v-divider class="ml-4"></v-divider>
        <Sidebar :drawer="drawer" @closeDrawer="closeDrawer()"></Sidebar>
        <main class="main">
            <slot></slot>
        </main>
        <!-- AI assistant bubble, bottom right (only shown to users the API allows it for) -->
        <AiChatBubble />
    </v-container>
</template>

<script>
import Sidebar from './Sidebar.vue'
import AiChatBubble from '@/components/ai-chat/AiChatBubble.vue'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export default {
    data: () => ({
        drawer: false,
        currentDateTime: '',
        userTimezone: '',
        _timer: null,
    }),
    components: {
        Sidebar,
        AiChatBubble,
    },
    computed: {
        ...mapGetters({
            getPageName: 'pageNameStore/getPageName',
            getPageBadges: 'pageNameStore/getPageBadges',
            get_user: 'auth/get_user',
        })
    },
    mounted() {
        this.userTimezone = dayjs.tz.guess()
        this.updateDateTime()
        this._timer = setInterval(this.updateDateTime, 60000)
    },
    beforeDestroy() {
        clearInterval(this._timer)
    },
    methods: {
        closeDrawer() {
            this.drawer = false
        },
        updateDateTime() {
            this.currentDateTime = dayjs().tz(this.userTimezone).format('MMM DD, YYYY hh:mm A')
        }
    }
}
</script>

<style lang="scss">

.v-app-bar-title__content {
    width: 50% !important;
}

.main-app-bar {
    background-color: #FFF !important;
}

.main-app-bar-title {
    font-family: 'Manrope';
    font-size: 24px;
    font-weight: bolder !important;
    padding-bottom:4px;
}

.main-app-bar-badge {
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
    padding: 2px 12px;
    border-radius: 14px;
    background: #E6F1F6;
    color: #3988AA;
    font-family: 'Manrope';
    font-size: 15px;
    font-weight: 700;
    line-height: 1.5;
}

.main-app-bar-subtitle {
    font-size: 10px;
}

.v-menu__content {
    box-shadow: none;
}

.app-bar-info-card {
    border: 1px solid #E9E9E9;
    border-radius: 20px;
    padding: 6px 14px;
    line-height: 1.4;
    background: #fff;
}

.app-bar-info-name {
    font-family: 'Manrope';
    font-size: 13px;
    font-weight: 700;
    color: #222;
    white-space: nowrap;
}

.app-bar-info-sub {
    font-family: 'Manrope';
    font-size: 11px;
    color: #7C7C7C;
    white-space: nowrap;
}

@media (min-width: 960px) {
    .app-bar-info-name {
        font-size: 15px;
    }

    .app-bar-info-sub {
        font-size: 12px;
    }
}
</style>
